var DOMAIN_STORAGE_ID = 'hn-skills-report-domain';
export var saveDomain = function (domainId) {
    return localStorage.setItem(DOMAIN_STORAGE_ID, String(domainId));
};
export var getDomain = function () {
    return Number(localStorage.getItem(DOMAIN_STORAGE_ID));
};
